module.exports = __webpack_public_path__ + "static/media/Menu-close.75f47bd1.svg";